
module dgUtils {

    export interface IDgEnabledLinksFilter extends Function {
        (links: dg.restfulApi.Links): dg.restfulApi.Link[];
    }

    function dgEnabledLinks($filter: dgUtils.IFilterService): IDgEnabledLinksFilter {
        return (links: dg.restfulApi.Links) => {
            return $filter('filter')(Object.keys(links).map(e => links[e]), (link: dg.restfulApi.Link, index) => {
                return !link.disabledReason;
            });
        }
    }
    angular.module('dgUtils')
        .filter('dgEnabledLinks', ['$filter', dgEnabledLinks]);
}